import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";

import SvgIcon from "@mui/material/SvgIcon";

import {GroheArchitectureIcon} from "../../../common/icons";
import LeadCapturePopupBoxImage from "./leadCapturePopupBoxImage";
import {capitalizeFirstLetters} from "../../../../misc/helpers";
import {getCommonVisualizerType} from "../../../../config";


const LeadCapturePopupBox = (props) => {

  const {fabricatorData, intl, lookOverlayAction} = props;

  const fromAI = lookOverlayAction === "aiLeadCapture";
  const titleId = fromAI ? "leadCapturePopup.box.title.aiLeadCapture" : "leadCapturePopup.design.title";
  const subTitleId = fromAI
    ? "leadCapturePopup.box.subTitle.aiLeadCapture"
    : document.kvConfig.visualizerOnly ? "leadCapturePopup.design.subTitleVisOnly" : "leadCapturePopup.design.subTitle";

  return (
    <div className="grohe-lead__right">
      <div className="grohe-lead__canvas">
        <LeadCapturePopupBoxImage className="grohe-lead__canvas-image animate__background-slide"/>
      </div>
      <div className={"grohe-lead__box" + (fabricatorData.isEncore || fabricatorData.isNhance ? " grohe-lead__box--small" : "")}>
        <div className="grohe-lead__box-icon">
          <SvgIcon style={{ fontSize: "inherit" }}>
            <GroheArchitectureIcon/>
          </SvgIcon>
        </div>
        <p className="grohe-lead__box-title bold">
          <FormattedMessage id={titleId} values={{
            visualizerType: capitalizeFirstLetters(intl.formatMessage({id: "rooms." + getCommonVisualizerType()}))
          }}/>
        </p>
        {fabricatorData.isEncore || fabricatorData.isNhance ? null : (
          <p className="grohe-lead__box-sub-title">
            <FormattedMessage id={subTitleId}/>
          </p>
        )}
      </div>
    </div>
  )
};

export default injectIntl(LeadCapturePopupBox)
